module.exports = __webpack_public_path__ + "static/media/start.84aec9d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start.mp3
// module id = h8pf
// module chunks = 1